import React, { useState } from "react";
import { BoardButton, BoardProgressBar } from "../../atoms/BoardDesignSystem";
import "./BoardChecklistEditor.scss";

const BoardChecklistEditor = ({
  items = [],
  onChange,
  disabled = false,
}) => {
  const [newText, setNewText] = useState("");

  const done = items.filter((i) => i.checked).length;

  const updateItem = (index, patch) => {
    const next = items.map((item, i) => (i === index ? { ...item, ...patch } : item));
    onChange?.(next);
  };

  const removeItem = (index) => {
    onChange?.(items.filter((_, i) => i !== index));
  };

  const addItem = () => {
    const text = newText.trim();
    if (!text) return;
    onChange?.([...items, { text, checked: false }]);
    setNewText("");
  };

  return (
    <div className="board-checklist-editor">
      {items.length > 0 && (
        <BoardProgressBar value={done} max={items.length} label="Progress" />
      )}
      <ul className="pb-checklist board-checklist-editor__list">
        {items.map((item, idx) => (
          <li key={`${idx}-${item.text}`} className="pb-checklist__item">
            <button
              type="button"
              className="pb-checklist__check-btn"
              onClick={() => !disabled && updateItem(idx, { checked: !item.checked })}
              disabled={disabled}
              aria-label={item.checked ? "Mark incomplete" : "Mark complete"}
              aria-pressed={Boolean(item.checked)}
            >
              <span
                className={`pb-checklist__check ${item.checked ? "pb-checklist__check--checked" : ""}`}
                aria-hidden="true"
              >
                {item.checked && <span className="pb-checklist__check-icon">✓</span>}
              </span>
            </button>
            <span
              className={`pb-checklist__text ${item.checked ? "pb-checklist__text--done" : ""}`}
            >
              {item.text}
            </span>
            {!disabled && (
              <button
                type="button"
                className="board-checklist-editor__remove"
                onClick={() => removeItem(idx)}
                aria-label="Remove item"
              >
                ✕
              </button>
            )}
          </li>
        ))}
      </ul>
      {!disabled && (
        <div className="board-checklist-editor__add">
          <input
            type="text"
            className="board-checklist-editor__input"
            value={newText}
            onChange={(e) => setNewText(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && addItem()}
            placeholder="Add checklist item..."
          />
          <BoardButton variant="secondary" size="sm" onClick={addItem} disabled={!newText.trim()}>
            Add
          </BoardButton>
        </div>
      )}
    </div>
  );
};

export default BoardChecklistEditor;
